// export { default as Impact } from './impact';
import { useFlags } from 'launchdarkly-react-client-sdk';

import ImpactForm from './impact';
import ImpactFormNew, { Props } from './impactNew';

export const Impact = ({ closeModal }: Props) => {
  const { enableDateTimeUpdates } = useFlags();

  return enableDateTimeUpdates ? (
    <ImpactFormNew closeModal={closeModal} />
  ) : (
    <ImpactForm closeModal={closeModal} />
  );
};
